import { create } from 'zustand';

/** Cursor position in world metres. Separate tiny store so mouse moves don't re-render the app. */
export const useCursor = create<{ x: number; z: number; inside: boolean }>(() => ({
  x: 0,
  z: 0,
  inside: false,
}));

/** Live measurement readout (metres). */
export const useMeasure = create<{ length: number; points: number; area: number | null }>(() => ({
  length: 0,
  points: 0,
  area: null,
}));
